import axios from 'axios'
import Cookie from 'js-cookie'
import { appENV, checkWindowLocation } from 'utils/dom'

import { RefreshTokenResponse } from './Identity/Types/RefreshTokenResponse'
import { host } from './index'

export class TokenStorage {
  static readonly REFRESH_TOKEN = '__Host_tm-refresh-token'
  static readonly ACCESS_TOKEN = '__Host_tm-access-token'
  static readonly SESSION = 'session'

  public static isAuthenticated(): boolean {
    return !!this.getToken()
  }

  public static getAccessToken(): string | undefined {
    return this.getToken()
  }

  public static getRefreshToken(): string | undefined {
    return this.getToken()
  }

  public static getSession(): string | undefined {
    return this.getSessionId()
  }

  public static getNewToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      const refreshToken = this.getRefresh()
      const sessionId = this.getSession()
      if (!refreshToken) {
        return reject('No refresh token.')
      }
      if (!sessionId) {
        return reject('No active session.')
      }

      axios
        .post(`${host}/identity/access-tokens/refresh`, { sessionId, refreshToken })
        .then((response) => {
          const tokenResponse: RefreshTokenResponse = response.data
          if (tokenResponse.accessToken && tokenResponse.refreshToken) {
            this.storeAccessToken(tokenResponse.accessToken, tokenResponse.expires)
            this.storeRefreshToken(tokenResponse.refreshToken, tokenResponse.expires)
            this.storeSession(tokenResponse.sessionId)
            // store.dispatch(refreshUserToken(tokenResponse))
          }
          resolve(tokenResponse.accessToken)
        })
        .catch((error) => {
          console.log('error from refresh token', error)
          reject(error)
        })
    })
  }

  public static storeAccessToken(token: string, expires: number | Date | undefined): void {
    if (checkWindowLocation() === appENV.localhost) {
      Cookie.set(TokenStorage.ACCESS_TOKEN, token)
    } else {
      Cookie.set(TokenStorage.ACCESS_TOKEN, token, { expires, sameSite: 'Lax', secure: true })
    }
  }

  public static storeRefreshToken(refreshToken: string, expires: number | Date | undefined): void {
    if (checkWindowLocation() === appENV.localhost) {
      Cookie.set(TokenStorage.REFRESH_TOKEN, refreshToken)
    } else {
      Cookie.set(TokenStorage.REFRESH_TOKEN, refreshToken, {
        expires,
        sameSite: 'Lax',
        secure: true,
      })
    }
  }

  public static storeSession(sessionId: string): void {
    Cookie.set(TokenStorage.SESSION, sessionId)
  }

  public static clear(): void {
    const cookies = Cookie.get()
    Object.keys(cookies).forEach((cookieName) => {
      Cookie.remove(cookieName)
    })
  }

  public static getRefresh(): string | undefined {
    return Cookie.get(this.REFRESH_TOKEN)
  }

  public static getToken(): string | undefined {
    return Cookie.get(this.ACCESS_TOKEN)
  }

  public static getSessionId(): string | undefined {
    return Cookie.get(this.SESSION)
  }
}
